// extracted by mini-css-extract-plugin
export var container = "HomeResearchAndDevelopmentLink-module--container--QoMy-";
export var content = "HomeResearchAndDevelopmentLink-module--content--qxPG0";
export var graphic = "HomeResearchAndDevelopmentLink-module--graphic--Frapf";